export default __webpack_public_path__ + "static/media/facebook.8fb5f2b2.svg";